module.exports = __webpack_public_path__ + "img/Abschnittsleiter_Verpflegung.6d34a823.svg";